import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconSvg, Text, Tooltip } from '@/lib/v2/components';
import { InfoIcon } from '@/lib/v2/icons/outline';

export const METRIC_TOOLTIPS: Record<string, string> = {
  CLEANED: 'shipping.tooltipCleaned',
};

export interface ShippingMetricsTooltipProps {
  label: string;
  tooltipKey: string;
}

const ShippingMetricsTooltip = ({ label, tooltipKey }: ShippingMetricsTooltipProps) => {
  const { t } = useTranslation(['insights']);

  return (
    <div className="relative flex items-center">
      {label}
      <div className="absolute -right-7 -top-1">
        <Tooltip
          isDark
          alignment="center"
          content={
            <Text alignment="left" className="w-40 text-white" variant="text-sm">
              {t(tooltipKey)}
            </Text>
          }
          position="top"
        >
          <IconSvg height="12" strokeColor="secondary" svgComponent={<InfoIcon />} width="12" />
        </Tooltip>
      </div>
    </div>
  );
};

export default memo(ShippingMetricsTooltip);
